module.exports = window["emotionReact"];